export const HOME = '/'
export const PRODUCTS = '/products'
export const ABOUT_US = '/about'
export const WHAT_WE_DO = '/whatwedo'
export const PARTNERS = '/partners'
export const CONTACT_US = '/contact'
